export default {
  TO: {
    HELP: 'Participants on this order will also receive this message',
    SELECT: 'Leave empty for internal note, or add recipient(s) to send a comment'
  },
  TEXT: {
    PLACEHOLDER: 'Enter a comment or add an internal note'
  }
}
